// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"282":"03a51829","714":"7221598f"}[chunkId] + ".chunk.css";
};